import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('@/pages/home/page'));
const AboutUs = lazy(() => import('@/pages/about-us/page'));
const OurServices = lazy(() => import('@/pages/our-services/page'));
const Contact = lazy(() => import('@/pages/contact/page'));
const BookNow = lazy(() => import('@/pages/book-now/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about-us',
    element: <AboutUs />,
  },
  {
    path: '/our-services',
    element: <OurServices />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/book-now',
    element: <BookNow />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
